import { CustomButton } from '../../../customButton';
import { isNumber } from 'lodash';
import getAchievementIcon from '../../utils/getAchievementIcon';

export default function Progress({ isVisibleProgress, prize, progressData }) {
  const { proportion, percentage } = progressData;

  return (
    isVisibleProgress && (
      <div className={'achievement__progress'}>
        <div className={'achievement__progress-block'}>
          {isNumber(percentage) && (
            <div className={'achievement__progress-line'} style={{ '--progress': `${percentage}%` }} />
          )}
          {proportion && <div className={'achievement__progress-counter'}>{proportion}</div>}
        </div>
        {prize && (
          <CustomButton
            className={'achievement__progress-prize custom-button_transparent custom-button_progress-prize'}
            image={getAchievementIcon(prize)}
          />
        )}
      </div>
    )
  );
}
